import { render, staticRenderFns } from "./SearchCoinTwoWeek.vue?vue&type=template&id=24af5377&"
import script from "./SearchCoinTwoWeek.vue?vue&type=script&lang=js&"
export * from "./SearchCoinTwoWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports